const replaceAll = (str: string, target: string, replaceBy: string): string => str.split(target).join(replaceBy);

export default replaceAll;
